import { ExpensesEntitiesExpensableStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export function getStatusLabel(status: ExpensesEntitiesExpensableStatusEnum): string {
  const statuses: Record<string, string> = {
    ['reversed']: i18n.t('expenses_v2.expense.status.reversed'),
    ['draft']: i18n.t('expenses_v2.expense.status.draft'),
    ['approved']: i18n.t('expenses_v2.expense.status.approved'),
    ['pending']: i18n.t('expenses_v2.expense.status.pending'),
    ['rejected']: i18n.t('expenses_v2.expense.status.rejected'),
    ['in_payroll']: i18n.t('expenses_v2.expense.status.inPayroll'),
    ['sent_to_pay']: i18n.t('expenses_v2.expense.status.sentToPay'),
    ['paid']: i18n.t('expenses_v2.expense.status.paid'),
    ['changes_requested']: i18n.t('expenses_v2.expense.status.changesRequested'),
  }

  return statuses[status] ?? ''
}
